import { Store } from "svelte/store";
import localforage from 'localforage';

import sync from './utils/sync';

const ROSTER_KEY = 'fbt-roster';
const LINEUPS_KEY = 'fbt-lineups';
const GAME_INFO_KEY = 'fbt-gameinfo';
const DEPTH_CHART_KEY = 'fbt-depthChart';
const CONFIGURATION_KEY = 'fbt-configuration';
const BOOKMARKS_KEY = 'fbt-bookmarks';
const SECURITY_KEY = 'fbt-security';
const SYNCDATE_KEY = 'fbt-syncdate';

let lineups = [];
while (lineups.length < 6) {
	lineups.push({ 1: {}, 2: {}, 3: {}, 4: {}, 5: {}, 6: {}, 7: {}, 8: {}, 9: {} });
}
let depthChart = {};
for (var pos = 1; pos < 10; pos++) {
	depthChart[pos] = [{}, {}, {}, {}, {}];
}

let stagedSync = null;
let pullingFromServer = false;

const store = new Store({
	displayName: '$_APPNAME',
	/*#if _PROD
	server: 'https://fbtapi.dogrla.workers.dev',
	//#else */
	server: 'http://localhost:8787',
	//#endif
	innings: "6",
	hasExtraFielder: false,
	useDepthChartToFill: true,
	warnDepthChartMismatch: true,
	warnOutOfPosition: true,
	lineups: lineups,
	depthChart: depthChart,
	bookmarkedLineups: {},
	roster: [],
	view: 'splash',
	loadProgress: 0,
	progressMessage: 'Welcome!',
	opponent: null,
	gameDate: null,
	dialog: {
		title: '',
		message: '',
		isConfirm: false,
		show: false
	},
	teamName: '',
	loggedIn: false,
	email: '',
	token: '',
	buildHash: '$_VERSION',
	buildDate: '$_BUILDDATE',
	syncStatus: 'complete'
});

store.compute('activeRoster', ['roster'], function (roster) {
	return roster.filter(player => player.active);
});

store.compute('isNotInstalled', [], function() {
	/*#if _PROD
	return !window.navigator.standalone;
	//#else */
	return false;
	//#endif
});

store.on('state', async ({ current, changed }) => {
	const loadingFromLocalStorage = current.loadProgress < 100;
	// did something other than the view change?
	let syncData = changed.roster || changed.lineups || changed.gameDate || changed.opponent || changed.depthChart || changed.bookmarkedLineups;

	// check if any settings changed
	syncData = syncData || changed.useDepthChartToFill || changed.warnOutOfPosition || changed.warnDepthChartMismatch || changed.teamName;

	const needsStoredLocal = !loadingFromLocalStorage || pullingFromServer;
	
	if (changed.roster && needsStoredLocal) {
		localforage.setItem(ROSTER_KEY, current.roster).then(function () {
			console.log("Roster saved");
		});
	}

	if (changed.lineups && needsStoredLocal) {
		localforage.setItem(LINEUPS_KEY, current.lineups).then(function () {
			console.log("Lineups saved");
		});
	}

	if ((changed.gameDate || changed.opponent) && needsStoredLocal) {
		localforage.setItem(GAME_INFO_KEY, {
			opponent: current.opponent,
			date: current.gameDate
		}).then(function () {
			console.log("Game info saved");
		});
	}

	if (changed.depthChart && needsStoredLocal) {
		localforage.setItem(DEPTH_CHART_KEY, current.depthChart).then(function () {
			console.log("Depth chart saved");
		});
	}

	if (changed.bookmarkedLineups && needsStoredLocal) {
		localforage.setItem(BOOKMARKS_KEY, current.bookmarkedLineups).then(function () {
			console.log("Bookmarks saved");
		});
	}

	if ((changed.useDepthChartToFill || changed.warnDepthChartMismatch || changed.warnOutOfPosition || changed.teamName)&& needsStoredLocal) {
		localforage.setItem(CONFIGURATION_KEY, {
			useDepthChartToFill: current.useDepthChartToFill,
			warnOutOfPosition: current.warnOutOfPosition,
			warnDepthChartMismatch: current.warnDepthChartMismatch,
			teamName: current.teamName
		}).then(function () {
			console.log("Configuration saved");
		});
	}

	if (changed.token && needsStoredLocal) {
		localforage.setItem(SECURITY_KEY, {
			email: current.email,
			token: current.token
		}).then(function () {
			console.log("Security info saved");
		})
	}

	if (current.innings > current.lineups.length) {
		const updatedLineups = [...current.lineups];
		while (updatedLineups.length < current.innings) {
			if (!current.hasExtraFielder) {
				updatedLineups.push({ 1: {}, 2: {}, 3: {}, 4: {}, 5: {}, 6: {}, 7: {}, 8: {}, 9: {} });
			} else {
				updatedLineups.push({ 1: {}, 2: {}, 3: {}, 4: {}, 5: {}, 6: {}, 7: {}, 8: {}, 9: {}, 10: {} });
			}
		}
		store.set({ lineups: updatedLineups });
	} else if (current.innings < current.lineups.length) {
		const updatedLineups = current.lineups.slice(0, current.innings);
		store.set({ lineups: updatedLineups });
	}

	if (!loadingFromLocalStorage && current.view == 'splash') {
		if (store.get().loggedIn) {
			store.set({ view: 'innings' });
		} else {
			store.set({ view: 'login' });
		}
	}
	
	if (current.loggedIn && syncData) {
		if (stagedSync) {
			clearTimeout(stagedSync);
		}
		stagedSync = setTimeout(async () => {
			store.set({ syncStatus: 'syncing'});
			const syncDate = Date.now();
			const userData = {
				syncDate: syncDate,
				roster: current.roster,
				lineups: current.lineups,
				gameInfo: {
					gameDate: current.gameDate,
					opponent: current.opponent
				},
				depthChart: current.depthChart,
				bookmarks: current.bookmarkedLineups,
				settings: {
					useDepthChartToFill: current.useDepthChartToFill,
					warnDepthChartMismatch: current.warnDepthChartMismatch,
					warnOutOfPosition: current.warnOutOfPosition,
					teamName: current.teamName
				},
				user: current.email
			}
			const res = await sync.storeData(userData, store.get().server, store.get().token);
			if (res.success) {
				localforage.setItem(SYNCDATE_KEY, syncDate);
			}
			store.set({ syncStatus: 'complete'});
		}, 5000);
		store.set({ syncStatus: 'pending'});
		console.log("Sync is pending ...");
	}
});

// when the app initializes, load the state from local, and then read from server, if needed
(async () => {
	const roster = await localforage.getItem(ROSTER_KEY);
	let loadProgress = store.get().loadProgress;
	loadProgress += 20;
	if (roster !== null) {
		store.set({ roster: roster });
	}
	store.set({ loadProgress: loadProgress, progressMessage: "Rosters loaded" });

	const lineups = await localforage.getItem(LINEUPS_KEY);
	loadProgress += 10;
	if (lineups !== null) {
		const isXFielderSet = lineups[0]["10"] !== undefined;
		store.set({ lineups: lineups, innings: lineups.length.toString(), hasExtraFielder: isXFielderSet });
	}
	store.set({ loadProgress: loadProgress, progressMessage: "Lineups loaded"  });

	const depthChart = await localforage.getItem(DEPTH_CHART_KEY);
	loadProgress += 10;
	if (depthChart !== null) {
		store.set({ depthChart: depthChart });
	}
	store.set({ loadProgress: loadProgress, progressMessage: "Depth chart loaded"  });

	const bookmarks = await localforage.getItem(BOOKMARKS_KEY);
	loadProgress += 10;
	if (bookmarks !== null) {
		store.set({ bookmarkedLineups: bookmarks });
	}
	store.set({ loadProgress: loadProgress, progressMessage: "Favorites loaded"  });


	const gameInfo = await localforage.getItem(GAME_INFO_KEY);
	loadProgress += 5;
	if (gameInfo !== null) {
		store.set({ opponent: gameInfo.opponent, gameDate: gameInfo.date });
	}
	store.set({ loadProgress: loadProgress, progressMessage: "Current game info loaded"  });

	const configuration = await localforage.getItem(CONFIGURATION_KEY);
	loadProgress += 10;
	if (configuration !== null) {
		store.set({ 
			useDepthChartToFill: configuration.useDepthChartToFill,
			warnDepthChartMismatch: configuration.warnDepthChartMismatch,
			warnOutOfPosition: configuration.warnOutOfPosition,
			teamName: configuration.teamName
		});
	}
	store.set({ loadProgress: loadProgress, progressMessage: "Configuration updated"  });

	const securityInfo = await localforage.getItem(SECURITY_KEY);
	loadProgress += 5;
	if (securityInfo !== null) {
		store.set({
			email: securityInfo.email,
			token: securityInfo.token,
			loggedIn: true
		});
	}
	store.set({ loadProgress: loadProgress, progressMessage: "User info loaded"  });


	store.set({ loadProgress: loadProgress, progressMessage: "Synchronizing with the server"  });
	if (securityInfo && securityInfo.email && securityInfo.token) {
		const lastServerSync = await sync.getLastSyncDate(store.get().server, securityInfo.token);
		if (lastServerSync.success) {
			const localSyncDate = await localforage.getItem(SYNCDATE_KEY);
			if (!localSyncDate || localSyncDate < lastServerSync.syncDate) {
				// our local data is out of date with the server
				// so pull what's on the server and replace things
				console.log('Local data is stale ... pulling from server');
				pullingFromServer = true;
				const currentData = await sync.getData(store.get().server, securityInfo.token);
				store.set({innings: `${currentData.lineups.length}`});
				store.set({roster: currentData.roster, lineups: currentData.lineups});
				store.set({depthChart: currentData.depthChart});
				store.set({bookmarkedLineups: currentData.bookmarks});
				store.set({opponent: currentData.gameInfo.opponent, gameDate: currentData.gameInfo.gameDate});
				store.set({
					useDepthChartToFill: currentData.settings.useDepthChartToFill,
					warnDepthChartMismatch: currentData.settings.warnDepthChartMismatch,
					warnOutOfPosition: currentData.settings.warnOutOfPosition,
					teamName: currentData.settings.teamName
				});
				localforage.setItem(SYNCDATE_KEY, lastServerSync.syncDate);
			} else {
				console.log('Local data is same or newer');
			}
			pullingFromServer = false;
		}
	}
	loadProgress += 30;
	store.set({ loadProgress: loadProgress, progressMessage: "Sync complete" });
})();

export default store;